export default __webpack_public_path__ + "static/media/no_HS.8915013b.svg";